import angular from 'angular';
import uiRouter from 'angular-ui-router';
import querychangesComponent from './querychanges.component';

let querychangesModule = angular.module('querychanges', [
  uiRouter
])

.component('querychanges', querychangesComponent);

export default querychangesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/querychanges/querychanges.js